import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import withStyles from "material-ui/styles/withStyles";

import {StripeProvider, Elements, CardElement, injectStripe} from 'react-stripe-elements';

import { postPaymentToken, getPaymentSources, deletePaymentSource, getAllPayments } from '../../actions/payment'

import SweetAlert from "react-bootstrap-sweetalert";
import NumberFormat from 'react-number-format';
import moment from 'moment';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Table from "components/Table/Table.jsx";

// material-ui icons
import Close from "@material-ui/icons/Close";

import {stripe} from "variables/variables.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
const creditcardPageStyle = {
  ...extendedTablesStyle,
  ...sweetAlertStyle,
}

class _CardForm extends React.Component {
  constructor(props) {
    super(props);
    this.handle = this.handle.bind(this);
  }

  handle(event){
    event.preventDefault();

    const { stripe, user, onToken } = this.props;
    
    stripe.createToken()
    .then((result) => {
      console.log('Received Stripe token:', result);
      let token = result.token.id;
      onToken(token);
    });

  }

  render() {
    return (
      <form onSubmit={this.handle}>
        <label>
          Card details            
          <CardElement />
        </label>
        <button>
          Add Card
        </button>    
      </form>
    )
  }
}
const CardForm = injectStripe(_CardForm)


class CreditCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creditcards: [],
      payments: [],
    };
    this.handleToken = this.handleToken.bind(this);
  }

  handleToken(token){
    let data = {
      token: token
    }
    this.props.dispatchPostPaymentToken(this.props.auth.user, data)
    .then( (res) => {
        return this.props.dispatchGetPaymentSources(this.props.auth.user);
    }).then( creditcards => {
      this.setState({creditcards});
      this.hideAlert();
    });
  }


  handleTableAction(action, id){
    if(action==="delete"){
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => this.handleConfirmDelete(id)}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText="Yes, delete it!"
            cancelBtnText="Cancel"
            showCancel
          >
            You will not be able to recover this imaginary file!
          </SweetAlert>
        )
      });  
    }  

  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  handleConfirmDelete(id){
    this.props.dispatchDeletePaymentSource(this.props.auth.user, {id} )
    .then( res => {
      return this.props.dispatchGetPaymentSources(this.props.auth.user);
    })
    .then( creditcards => {
      this.setState({creditcards});
      this.hideAlert();
    });
  }



  componentDidMount() {
    this.props.dispatchGetPaymentSources(this.props.auth.user)
    .then( creditcards => {
      this.setState({creditcards});
    });   

    this.props.dispatchGetPayments(this.props.auth.user)
    .then( payments => {
      console.log(payments);
      this.setState({payments});
    });       
  }

  render() {
    const {  classes, translate, userDetails } = this.props;

    var creditcardTableData = [];
    if(this.state.creditcards.length>0){
      this.state.creditcards.map((prop,key)=>{
        
        let fillButtons = [
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        creditcardTableData.push([prop.brand, "**** "+prop.last4, prop.exp_month+"/"+prop.exp_year, key===0?"Yes":"No",fillButtons]);
        return false;
      });
    }    

    var paymentsTableData = [];
    if(this.state.payments.length>0){
      this.state.payments.map((prop,key)=>{
        let amount = (<NumberFormat value={prop.amount/100} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />);
        paymentsTableData.push([ moment(prop.created*1000).format('MMM Do YYYY, h:mm a'), amount, prop.description, "**** "+prop.source.last4]);
        return false;
      });
    }        

    return (
      <div>
        <GridContainer>
          {this.state.alert}  
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.creditcard.content")} />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              iconColor="rose"
              title="Edit"
              content={
                <StripeProvider apiKey={stripe.publicKey}>
                  <Elements>
                    <CardForm 
                      user={userDetails}
                      onToken={this.handleToken}
                    />
                  </Elements>
                </StripeProvider>
              }
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              iconColor="rose"
              title="My Creditcards"
              content={
                <Table
                  tableHead={[
                    "Brand",
                    "Number",
                    "Expiry",
                    "Default",
                    "Actions"
                  ]}
                  tableData={creditcardTableData}
                />
              }
            />
          </ItemGrid>    
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              iconColor="rose"
              title="My Payments"
              content={
                <Table
                  tableHead={[
                    "Date",
                    "Amount",
                    "Description",
                    "Card"
                  ]}
                  tableData={paymentsTableData}
                />
              }
            />
          </ItemGrid>                     
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = {
  dispatchPostPaymentToken: (user, data) => postPaymentToken(user, data),
  dispatchGetPaymentSources: (user) => getPaymentSources(user),
  dispatchDeletePaymentSource: (user, data) => deletePaymentSource(user, data),
  dispatchGetPayments: (user) => getAllPayments(user),  
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
  }
}


export default compose(
  withStyles(creditcardPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(CreditCard);




// WEBPACK FOOTER //
// ./src/views/Customer/CreditCard.jsx